import React, { Component } from 'react'
import Web3 from 'web3'
import './css.css';



class FreeToken extends Component {
constructor(props){
    super()
    this.state={favorite:false}

}


setCookie(cname, cvalue,id) {
    let s=this.getCookie(cname)
    let arr=s.split(",")
    let arr2=[]
    let t=false
    for(let i=0;i<arr.length;i++){
        if(arr[i]==cvalue+"_"+id){
            t=true
           
        }else{
            arr2.push(arr[i])
        }
    }
  
    if(!t){
        arr2.push(cvalue+"_"+id)
      
    }
    document.cookie = cname + "=" + arr2.toString() + ";"
    this.loadToken()
}

getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }


async grab(){
        let addr=this.props.address
        let tick=this.props.ticket
    await window.ethereum.enable().then(async function (accounts) { 
            const { REACT_APP_FREEBIES1_0ABI } = process.env;
            const door = new web3.eth.Contract(JSON.parse(REACT_APP_FREEBIES1_0ABI), tick) 
            await door.methods.claim(addr).send({from: accounts[0] , gasLimit: 223456 })
           
    })  
    this.loadToken()
}

async setAmount(){
    let addr=this.props.address
    let index=this.props.index
    let priceList=this.props.priceList
    await window.ethereum.enable().then(async function (accounts) { 
        const { REACT_APP_PriceListABI } = process.env;
        
        const prices = new web3.eth.Contract(JSON.parse(REACT_APP_PriceListABI), priceList) 
        await prices.methods.setPrice(addr,web3.utils.toWei(document.getElementById("Shop_item_setprice_field_"+index).value,'ether')).send({from: accounts[0] , gasLimit: 323456 })
        document.getElementById('Shop_item_price_'+index).innerHTML=document.getElementById("Shop_item_setprice_field_"+index).value
    })  
    this.loadToken()
}

calculate_price(){
    let price=parseInt(document.getElementById('Shop_item_setamount_field_'+this.props.index).value)*parseInt(this.props.price)/1000
    document.getElementById("cost_"+this.props.index).style="text-align:right;"
    document.getElementById('cost_'+this.props.index).value=price
}

async loadToken(){
    let addr=this.props.address
    let index=this.props.index
    let ticket=this.props.ticket
    let s=this.getCookie("favorite")
    let arr=s.split(",")
    let t=false
    //alert(arr)
    document.getElementById("favorite_"+index).style.opacity=0.3
    for(let i=0;i<arr.length;i++){
    //if("_"+arr[i].substr(0,arr[i].indexOf("_"))=="_"+addr)
    if(arr[i]==addr+"_"+index)
    document.getElementById("favorite_"+index).style.opacity=1
    }
    await window.ethereum.enable().then(async function (accounts) { 
        try{ 
            const { REACT_APP_ABI } = process.env; 
            const { REACT_APP_TICKETABI } = process.env; 
        const tick = new web3.eth.Contract(JSON.parse(REACT_APP_TICKETABI), ticket)
        const tkn = new web3.eth.Contract(JSON.parse(REACT_APP_ABI), addr) 
        let name = await tkn.methods.name().call()
        let box = await tick.methods.box().call()
        document.getElementById("Shop_item_"+index).innerHTML=name
        let dec = await tkn.methods.decimals().call()
        let symbol = await tkn.methods.symbol().call()
    
        let bal = await tkn.methods.balanceOf(box).call()
        bal=bal/Math.pow(10,dec)
        
        document.getElementById("Shop_item_setamount_field_"+index).value=bal
        document.getElementById("cost_"+index).style="text-align:left;"
        document.getElementById("cost_"+index).value=symbol
        }catch(e){}
})
this.render()
}

    componentDidMount(){
        this.loadToken()
      
    }

    render(props){
    console.log("FREE TOKEN PROPS>",this.props)

    
        return ( 
            <div className="row_container">
             <div id={"favorite_"+this.props.index} className={(this.state.favorite)?"favorite":"notfavorite"} onClick={() => this.setCookie("favorite",this.props.address,this.props.index)}>⭐️</div>
        <div className="Shop_row">       
        
            <div className="Shop_item_panel">
               <img className="Shop_item_icon" onClick={() => window.open('https://etherscan.io/address/'+this.props.memory)} src="https://dapp.dfohub.com/assets/img/default-logo.png"></img>
               <div id={"Shop_item_"+this.props.index} className="Shop_item_label">loading...</div>
               <div className="Shop_item_price_icon" src="https://i.imgur.com/FPL7c5a.png">🎀</div>
               <span id={"Shop_item_price_"+this.props.index} className="Shop_item_price right">{(this.props.price)/1000000000000000000}</span>
               <div className="clear"></div>
                {(this.props.edit)?
                <div className="Shop_item_setprice">
                    <input id={"Shop_item_setprice_field_"+this.props.index} className="Shop_item_setamount_field" type="text"></input>
                    <input className="Shop_item_setprice_button" type="button" value="✒️ Set Amount" onClick={() => this.setAmount()}></input>
                </div>
                :
               <div className="Shop_item_setprice">
                   <input id={"Shop_item_setamount_field_"+this.props.index} className="Shop_item_setamount_field" type="text"></input>
                   <img className="Shop_item_icon"  src="https://dapp.dfohub.com/assets/img/default-logo.png"></img>
                   <input  id={"cost_"+this.props.index} className="Shop_item_setamount_field" type="text"  ></input>

                   <input className="Shop_item_setprice_button" type="button" value="🖐 grab" onClick={() => this.grab()}></input>
               </div>
    }
                
               </div>
        </div>
            </div>
        );
    }


}

function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}



        
const web3 = new Web3(Web3.givenProvider || "http://localhost:8545")




export default FreeToken